import { inject } from 'vue'
import { getCashBoxModal } from 'common/lazy-components.js'
import { getConfig } from '@/configs/index.js'

const config = getConfig()

export function useCashBox(modal) {
  const appModal = modal || inject('appModal')

  function open(
    props = { initTab: 'topup', showNavigationProp: true, oldMoneyOrderUuid: '' },
    options = { isBigSize: null },
  ) {
    if (config.cashboxDeepLink) {
      config.cashboxDeepLink(props.initTab)
      return
    }

    if (!appModal?.open) {
      return
    }

    return appModal.open({ componentName: getCashBoxModal(), props, ...options })
  }

  return {
    open,
  }
}
